// extracted by extract-css-chunks-webpack-plugin
module.exports = {"expenseCalculator":"_16Ax6x","modal":"_30dltP","open":"_30hBSq"};